var React = require('react');

function XCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"10","key":0}),React.createElement("line",{"x1":"15","y1":"9","x2":"9","y2":"15","key":1}),React.createElement("line",{"x1":"9","y1":"9","x2":"15","y2":"15","key":2})]);
}

XCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-x-circle"};

module.exports = XCircle;

XCircle.default = XCircle;
